<template>
  <v-dialog v-model="internalDialog" max-width="900px" scrollable persistent content-class="buscar-doc-dialog">
    <v-card class="overflow-hidden" style="border-radius:4px">
      <!-- HEADER -->
      <v-toolbar flat height="56" color="#37474f" dark class="flex-shrink-0">
        <v-icon class="mr-2">mdi-file-search-outline</v-icon>
        <v-toolbar-title class="font-weight-black text-uppercase" style="letter-spacing:1px;font-size:0.9rem;">Seleccionar Documento</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <!-- TABS -->
      <v-tabs
        v-model="tab"
        background-color="#37474f"
        color="white"
        dark
        grow
        height="48"
        class="flex-shrink-0"
      >
        <v-tab href="#facturas" class="font-weight-bold text-uppercase" style="font-size:0.75rem;letter-spacing:0.8px">
          <v-icon left small>mdi-file-document-outline</v-icon>
          Facturas
        </v-tab>
        <v-tab href="#tiquetes" class="font-weight-bold text-uppercase" style="font-size:0.75rem;letter-spacing:0.8px">
          <v-icon left small>mdi-ticket-outline</v-icon>
          Tiquetes
        </v-tab>
      </v-tabs>

      <v-card-text class="pa-0 bg-light">
        <v-tabs-items v-model="tab">
          <!-- TAB FACTURAS -->
          <v-tab-item value="facturas">
            <div class="pa-3 d-flex align-center">
              <v-text-field
                v-model="search"
                append-inner-icon="mdi-magnify"
                label="Buscar factura por cliente o código..."
                single-line
                hide-details
                outlined
                dense
                class="search-field"
              ></v-text-field>
              <v-btn icon color="blue-grey darken-2" class="ml-2" @click="getData">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </div>
            
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              :loading="loading"
              class="custom-table"
              fixed-header
              height="400px"
              :items-per-page="10"
            >
              <template v-slot:[`item.totalComprobante`]="{ item }">
                <span class="font-weight-bold primary--text">
                  {{ item.moneda }} {{ item.totalComprobante | formatMoney }}
                </span>
              </template>
              
              <template v-slot:[`item.estadoHacienda`]="{ item }">
                <v-chip
                  small
                  :color="getStatusColor(item.estadoHacienda)"
                  text-color="white"
                  class="font-weight-bold"
                >
                  {{ item.estadoHacienda }}
                </v-chip>
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <v-btn
                  color="blue-grey darken-2"
                  small
                  depressed
                  dark
                  style="border-radius:4px"
                  @click="selected(item)"
                  class="px-3 font-weight-bold"
                >
                  <v-icon left size="14">mdi-check</v-icon> Seleccionar
                </v-btn>
              </template>
            </v-data-table>
          </v-tab-item>

          <!-- TAB TIQUETES -->
          <v-tab-item value="tiquetes">
            <div class="pa-3 d-flex align-center">
              <v-text-field
                v-model="search2"
                append-inner-icon="mdi-magnify"
                label="Buscar tiquete por cliente o código..."
                single-line
                hide-details
                outlined
                dense
                class="search-field"
              ></v-text-field>
              <v-btn icon color="blue-grey darken-2" class="ml-2" @click="getData2">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </div>

            <v-data-table
              :headers="headers2"
              :items="items2"
              :search="search2"
              :loading="loading"
              class="custom-table"
              fixed-header
              height="400px"
              :items-per-page="10"
            >
              <template v-slot:[`item.totalComprobante`]="{ item }">
                <span class="font-weight-bold primary--text">
                  {{ item.moneda }} {{ item.totalComprobante | formatMoney }}
                </span>
              </template>

              <template v-slot:[`item.estadoHacienda`]="{ item }">
                <v-chip
                  small
                  :color="getStatusColor(item.estadoHacienda)"
                  text-color="white"
                  class="font-weight-bold"
                >
                  {{ item.estadoHacienda }}
                </v-chip>
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <v-btn
                  color="blue-grey darken-2"
                  small
                  depressed
                  dark
                  style="border-radius:4px"
                  @click="selected2(item)"
                  class="px-3 font-weight-bold"
                >
                  <v-icon left size="14">mdi-check</v-icon> Seleccionar
                </v-btn>
              </template>
            </v-data-table>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      
      <v-divider></v-divider>
      <v-card-actions class="pa-3" style="background:#f8fafc;border-top:1px solid rgba(0,0,0,0.08)">
        <v-spacer></v-spacer>
        <v-btn text class="font-weight-bold" style="border-radius:4px" @click="close">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "BuscarDocumentosND",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      internalDialog: false,
      tab: 'facturas',
      search: "",
      search2: "",
      loading: false,
      headers: [
        { text: "Código", align: "start", value: "codigoFact", class: "grey lighten-4" },
        { text: "Cliente", value: "clienteNombre", class: "grey lighten-4" },
        { text: "Fecha", value: "fechaString", class: "grey lighten-4" },
        { text: "Total", value: "totalComprobante", align: "end", class: "grey lighten-4" },
        { text: "Estado", value: "estadoHacienda", align: "center", class: "grey lighten-4" },
        { text: "Acción", value: "actions", align: "center", sortable: false, class: "grey lighten-4" },
      ],
      headers2: [
        { text: "Código", align: "start", value: "codigoFact", class: "grey lighten-4" },
        { text: "Cliente", value: "clienteNombre", class: "grey lighten-4" },
        { text: "Fecha", value: "fechaString", class: "grey lighten-4" },
        { text: "Total", value: "totalComprobante", align: "end", class: "grey lighten-4" },
        { text: "Estado", value: "estadoHacienda", align: "center", class: "grey lighten-4" },
        { text: "Acción", value: "actions", align: "center", sortable: false, class: "grey lighten-4" },
      ],
      items: [],
      items2: [],
    };
  },

  computed: {
    ...mapGetters(["strCia"]),
  },

  watch: {
    dialog(val) {
      this.internalDialog = val;
      if (val) {
        this.tab = 'facturas';
        this.search = "";
        this.search2 = "";
        this.items = [];
        this.items2 = [];
        this.getData();
        this.getData2();
      }
    },
    internalDialog(val) {
      if (!val) {
        this.$emit("closed");
      }
    }
  },

  filters: {
    formatMoney(value) {
      if (!value) return "0.00";
      return parseFloat(value).toLocaleString("es-CR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },

  methods: {
    getStatusColor(status) {
      switch (status) {
        case "ACEPTADO": return "success";
        case "RECHAZADO": return "error";
        case "PROCESANDO": return "info";
        default: return "grey";
      }
    },

    getData() {
      let me = this;
      me.loading = true;
      axios
        .get(
          "api/Facturacion/getComprobantesAll?cia=" +
            this.strCia +
            "&docNombre=Facturas&tipoDoc=01"
        )
        .then(function (response) {
          me.items = response.data;
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {
          me.loading = false;
        });
    },

    getData2() {
      let me = this;
      me.loading = true;
      axios
        .get(
          "api/Facturacion/getComprobantesAll?cia=" +
            this.strCia +
            "&docNombre=Tiquetes&tipoDoc=04"
        )
        .then(function (response) {
          me.items2 = response.data;
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {
          me.loading = false;
        });
    },

    selected(item) {
      const selectedItem = Object.assign({}, item);
      selectedItem.documentoOrigen = "Factura Electrónica";
      selectedItem.ordenCompra = "";
      selectedItem.mensajeHacienda = "";
      selectedItem.observacion = "";
      selectedItem.estadoHacienda = "";
      selectedItem.codigoDev = selectedItem.clavehacienda;
      selectedItem.clavehacienda = "";
      selectedItem.nombreTabla = "NotasDebito";
      selectedItem.NombreTablaReferencia = "Facturas";
      selectedItem.nombreTablaReferencia = "Facturas";

      this.$emit("clicked", selectedItem);
      this.close();
    },

    selected2(item) {
      const selectedItem = Object.assign({}, item);
      selectedItem.documentoOrigen = "Tiquete Electrónico";
      selectedItem.ordenCompra = "";
      selectedItem.mensajeHacienda = "";
      selectedItem.observacion = "";
      selectedItem.estadoHacienda = "";
      selectedItem.codigoDev = selectedItem.clavehacienda;
      selectedItem.clavehacienda = "";
      selectedItem.nombreTabla = "NotasDebito";
      selectedItem.NombreTablaReferencia = "Tiquetes";
      selectedItem.nombreTablaReferencia = "Tiquetes";

      this.$emit("clicked", selectedItem);
      this.close();
    },

    close() {
      this.internalDialog = false;
    },
  },
};
</script>

<style scoped>
.bg-light { background-color: #f8f9fa !important; }
.bg-white { background-color: #ffffff !important; }
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.08) !important; }
.shadow-bottom { box-shadow: 0 2px 4px rgba(0,0,0,0.1) !important; }
.search-field { flex: 1; }
.opacity-80 { opacity: 0.8; }

.custom-table >>> thead th {
  background-color: #eceff1 !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  font-size: 0.72rem !important;
  letter-spacing: 0.07em;
  color: #546e7a !important;
  border-bottom: none !important;
}

.custom-table >>> tbody tr:hover {
  background-color: #f1f5f9 !important;
}
</style>